import React from 'react';
import PropTypes from 'prop-types';
import { Logo } from '@els/els-react--logo';
import './LoginFormHeader.scss';

function LoginFormHeader({ ipAddress, actionMessage, infoMessage, headerText, subtitleText, descriptionMessage, children }) {
  return (
    <>
      <div className="login-form-header__buttons">
        {ipAddress && <div className="login-form-header__buttons_ip u-els-color-text">{`Your IP: ${ipAddress}`}</div>}
      </div>
      {children}
      <Logo className="elsevier-logo-register u-els-padding-top-1o2" />
      {headerText && (
        <h1 className="e2e-login-header login-form-header__actionMessage u-els-text-center u-els-margin-top-1x1o2 u-els-font-size-h3">
          {headerText}
        </h1>
      )}
      {subtitleText && (
        <p className="e2e-login-header login-form-header__actionMessage u-els-text-center u-els-margin-top-1x1o2 u-els-font-size-base">
          {subtitleText}
        </p>
      )}
      {descriptionMessage && (
        <h2 className="login-form-header__descriptionMessage u-els-line-height-1o4 u-els-text-start u-els-margin-top u-els-width-full u-els-margin-bottom">
          {descriptionMessage}
        </h2>
      )}
      {actionMessage && (
        <h1 className="e2e-login-header login-form-header__actionMessage u-els-text-center u-els-margin-top-1x1o2 u-els-font-size-h3">
          {actionMessage}
        </h1>
      )}
      {infoMessage && (
        <h2 className="login-form-header__infoMessage u-els-font-size-base u-els-line-height-1o4 u-els-text-center u-els-margin-top u-els-width-full u-els-margin-bottom-1x1o2">
          {infoMessage}
        </h2>
      )}
    </>
  );
}

LoginFormHeader.propTypes = {
  ipAddress: PropTypes.string,
  actionMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  infoMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  headerText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  subtitleText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  descriptionMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  children: PropTypes.node,
};

export default LoginFormHeader;
